'use client'

import { Provider as JotaiProvider } from 'jotai'
import { PropsWithChildren } from 'react'
import { createGlobalStore } from '@/store/global'
import { Tenant } from '@/payload-types'

interface ProvidersProps {
  tenant?: Tenant
}

export const Providers = ({ tenant, children }: PropsWithChildren<ProvidersProps>) => {
  const store = createGlobalStore(tenant ?? null)
  return <JotaiProvider store={store}>{children}</JotaiProvider>
}
